export default "__VITE_ASSET__db0bd1ab__"